import { Component } from 'react';
import { FavButtons, FavButtonsWrapper, FavCardWrapper, FavLayerText, FavTextEditInput, FavTextWrapper } from './PreferitsCardElement';
import React from 'react';
import { centerMapTo } from '../Utils/MapUtils';
import { transform } from 'ol/proj';
import { config } from '../../config/Config';
import { getTranslatedKey } from '../Utils/TranslateUtils';

export default class PreferitsCard extends Component {
  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
    this.state = {
      edit: false,
      text: this.favRender()
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.edit && !prevState.edit) {
      this.inputRef.current.focus();
    }
  }

  favRender = () => {
    let fav = this.props.fav;
    if (!fav.name) {
      if (fav.type === 'coords') {
        let formatCoord = fav.fav.map((coord) => coord.toFixed(2));
        let favStr = formatCoord.join(', ') + ' m';
        return favStr;
      }
    } else {
      return fav.name.toString().trim();
    }
  };

  handleText = (e) => {
    this.setState({ text: e.target.value });
  };

  startEdit = () => {
    this.setState({ edit: true });
    document.addEventListener('keydown', this.onEnter);
  };

  onEnter = (e) => {
    if (e.key === 'Enter') {
      this.applyName();
    }
  };

  applyName = () => {
    if (this.state.text !== '') {
      this.props.fav.name = this.state.text;
    }
    this.setState({ edit: false });
    document.removeEventListener('keydown', this.onEnter);
  };

  goToFav = () => {
    let fav = this.props.fav;
    if (fav.type === 'coords') {
      let coords = transform(fav.fav, config.EPSG, config.EPSG_mapa);
      centerMapTo(fav.fav, this.props.map, false, true, this.props.alturaInfoPunt, true);
      this.props.onClickMap([], null, coords, [coords[0], coords[1]]);
    } else {
      this.props.goToFavFeature(fav);
    }
  };

  deleteFav = () => {
    this.props.deleteFav(this.props.fav);
  };

  render() {
    return (
      <FavCardWrapper>
        <div style={{ overflow: 'hidden' }}>
          {!this.state.edit ? (
            <FavTextWrapper fontSizeEnabled={this.props.fontSizeEnabled}>{this.favRender()}</FavTextWrapper>
          ) : (
            <FavTextEditInput ref={this.inputRef} value={this.state.text} onChange={(e) => this.handleText(e)} />
          )}
          {this.props.fav.type !== 'coords' && (
            <FavLayerText fontSizeEnabled={this.props.fontSizeEnabled}>{this.props.fav.layer.getTitle()}</FavLayerText>
          )}
        </div>
        <FavButtonsWrapper>
          {!this.state.edit ? (
            <FavButtons title={getTranslatedKey('favEdit')} onClick={() => this.startEdit()}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="white" version="1.1" id="noEdit" viewBox="0 0 490 490" width="20">
                <path d="M443.9,75.8l-30.1-30.1c-16.1-16.1-44.2-16.1-60.2,0l-44.1,44.1l90.4,90.4l44.1-44.1c8.1-8,12.5-18.7,12.5-30.1  C456.4,94.6,451.9,83.9,443.9,75.8z" />
                <path d="M279.3,119.9L59.7,339.5c-1.4,1.4-2.4,3.2-2.8,5.1l-23.2,98.5c-0.9,3.6,0.2,7.4,2.8,10c2,2,4.7,3.1,7.5,3.1  c0.8,0,1.6-0.1,2.4-0.3l98.5-23.2c1.9-0.4,3.7-1.4,5.1-2.8l219.6-219.6L279.3,119.9z" />
              </svg>
            </FavButtons>
          ) : (
            <FavButtons title={getTranslatedKey('favApply')} onClick={() => this.applyName()}>
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="editando" fill="white" width="20" viewBox="0 0 490 490">
                <path d="M468.7,456.2h-277c-11.8,0-21.3-9.5-21.3-21.3c0-11.8,9.5-21.3,21.3-21.3h277c11.8,0,21.3,9.5,21.3,21.3  C490,446.6,480.5,456.2,468.7,456.2z" />
                <path d="M410.5,75.8l-30.1-30.1c-16.1-16.1-44.2-16.1-60.2,0l-44.1,44.1l90.4,90.4l44.1-44.1c8.1-8,12.5-18.7,12.5-30.1  C423,94.6,418.5,83.9,410.5,75.8z" />
                <path d="M245.9,119.9L26.3,339.5c-1.4,1.4-2.4,3.2-2.8,5.1L0.3,443.1c-0.9,3.6,0.2,7.4,2.8,10c2,2,4.7,3.1,7.5,3.1  c0.8,0,1.6-0.1,2.4-0.3l98.5-23.2c1.9-0.4,3.7-1.4,5.1-2.8l219.6-219.6L245.9,119.9z" />
              </svg>
            </FavButtons>
          )}
          <FavButtons title={getTranslatedKey('favZoom')} onClick={() => this.goToFav()}>
            <svg transform="scale(0.9)" viewBox="0 0 32 32" fill="white" xmlns="http://www.w3.org/2000/svg" version="1.1" width="22">
              <path d="M28.5259,3.1494a1,1,0,0,0-.9732-.0439L20,6.8818,12.4473,3.1055a1.0008,1.0008,0,0,0-.8946,0l-8,4A1,1,0,0,0,3,8V28a1,1,0,0,0,1.4473.8945L12,25.1182l3.5527,1.7763a1,1,0,0,0,.8946-1.789L13,23.3818V8a1,1,0,0,0-2,0V23.3818l-6,3V8.6182l7-3.5,7,3.5V14a1,1,0,0,0,2,0V8.6182l6-3V18a1,1,0,0,0,2,0V4A1,1,0,0,0,28.5259,3.1494Z"></path>
              <path d="M26.167,24.7529a5.015,5.015,0,1,0-1.4141,1.4141l2.54,2.54a1,1,0,0,0,1.414-1.414ZM19,22a3,3,0,1,1,3,3A3.0033,3.0033,0,0,1,19,22Z"></path>
            </svg>
          </FavButtons>
          <FavButtons title={getTranslatedKey('favDelete')} onClick={() => this.deleteFav()}>
            <svg viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg" version="1.1" width="22">
              <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"></path>
            </svg>
          </FavButtons>
        </FavButtonsWrapper>
      </FavCardWrapper>
    );
  }
}
